import toArray from '../helpers/toArray';

const videoPlayTogglers = toArray(document.querySelectorAll('.js-video-play-toggler'));
const backdropElements = toArray(document.querySelectorAll('.js-video-play-bg'));
const videoElements = toArray(document.querySelectorAll('.js-video-play video'));

const videoPlay = {
  initialize() {
    if (videoPlayTogglers.length) {
      this.createListeners();
    }
  },

  createListeners() {
    backdropElements.forEach((backdropElement) => {
      backdropElement.addEventListener('click', () => {
        this.pauseOtherVideos();
      });
    });

    videoElements.forEach((videoElement) => {
      // When the video is paused, remove is-playing to close the modal
      videoElement.addEventListener('pause', () => {
        const wrapper = this.getWrapper(videoElement);

        wrapper.classList.remove('is-playing');
      });

      // When the video is clicked, pause the video and close the modal
      videoElement.addEventListener('click', () => {
        const wrapper = this.getWrapper(videoElement);

        wrapper.classList.remove('is-playing');

        this.pauseOtherVideos();
      });
    });

    videoPlayTogglers.forEach((toggler) => {
      toggler.addEventListener('click', ({ currentTarget }) => {
        const wrapper = this.getWrapper(currentTarget);

        const modal = wrapper?.querySelector('.js-video-play-modal');

        if (!wrapper || !modal) {
          return;
        }

        this.pauseOtherVideos(wrapper);

        const video = wrapper.querySelector('video');

        if (!video) {
          return;
        }

        const isPlaying = this.isVideoPlaying(video);

        wrapper.classList[isPlaying ? 'remove' : 'add']('is-playing');

        // Play/pause the video
        video[isPlaying ? 'pause' : 'play']();
      });
    });
  },

  getWrapper(element) {
    return element.closest('.js-video-play');
  },

  pauseOtherVideos(currentWrapper) {
    videoPlayTogglers.forEach((videoPlayToggle) => {
      const wrapper = videoPlayToggle.closest('.js-video-play');

      const modal = wrapper?.querySelector('.js-video-play-modal');

      if (!wrapper || !modal) {
        return;
      }

      if (currentWrapper && wrapper === currentWrapper) {
        return;
      }

      wrapper.classList.remove('is-playing');

      const video = wrapper.querySelector('video');

      if (video) {
        video.pause();
      }
    });
  },

  isVideoPlaying(video) {
    return !!(video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2);
  },
};

export default videoPlay;
